export function getPhoneNumberFormat(str: string): string {
  return str.replace(/(\d{3})(\d{3})(\d{4})/, '($1) $2-$3');
}

export function getCurrencyFormat(str: string): string {
  const parts = str.split('.');
  const integralPart = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ',');
  return parts.length > 1 ? `${integralPart}.${parts[1]}` : integralPart;
}

export function getNumbers(str: string): string {
  return str.replace(/\D/g, '');
}

export function getFloat(str: string): string {
  return str.replace(/[^0-9\\.-]/g, '');
}

export function isNumeric(str: string): boolean {
  return /^[0-9]+$/.test(str);
}

export function escapeSpecialChars(str?: string) {
  if (!str || !str.length) return '';
  return str.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');
}

export function getNameInitials(str: string): string | undefined {
  if (!str) return undefined;
  return str
    .match(/(\b\S)?/g)
    ?.join('')
    ?.match(/(^\S|\S$)?/g)
    ?.join('')
    .toUpperCase();
}

export function removeWhiteSpaces(str: string): string {
  return str?.replace(/\s/g, '');
}

export function validateUrl(value: string) {
  return /^(?:(?:(?:https?|ftp):)?\/\/)(?:\S+(?::\S*)?@)?(?:(?!(?:10|127)(?:\.\d{1,3}){3})(?!(?:169\.254|192\.168)(?:\.\d{1,3}){2})(?!172\.(?:1[6-9]|2\d|3[0-1])(?:\.\d{1,3}){2})(?:[1-9]\d?|1\d\d|2[01]\d|22[0-3])(?:\.(?:1?\d{1,2}|2[0-4]\d|25[0-5])){2}(?:\.(?:[1-9]\d?|1\d\d|2[0-4]\d|25[0-4]))|(?:(?:[a-z\u00a1-\uffff0-9]-*)*[a-z\u00a1-\uffff0-9]+)(?:\.(?:[a-z\u00a1-\uffff0-9]-*)*[a-z\u00a1-\uffff0-9]+)*(?:\.(?:[a-z\u00a1-\uffff]{2,})))(?::\d{2,5})?(?:[/?#]\S*)?$/i.test(
    value,
  );
}

export function parseToNumber(str: string) {
  return Number(str.replace(/,/, ''));
}
